import get from "lodash.get";
import { createSelector } from "reselect";

const authFeatureSelector = (state: TReduxState) => state.root.features.auth;

export const getData = createSelector(authFeatureSelector, (app) =>
  get(app, "data", null)
);

export const getAuthValidationStates = createSelector(
  authFeatureSelector,
  (state) => get(state, "validationStates")
);

export const getAuthToken = createSelector(getData, (data) =>
  get(data, "rememberMe", false)
);

export const getCurrentLanguage = createSelector(getData, (data) =>
  get(data, "language", "KO")
);

export const getIsLoginLoading = createSelector(
  getAuthValidationStates,
  (validationStates) => get(validationStates, "login.isLoading", false)
);
